import {
  AfterViewInit,
  Component,
  Inject,
  OnInit,
  ViewChild,
} from '@angular/core';
import { Observable } from 'rxjs/internal/Observable';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { MatSnackBar } from '@angular/material/snack-bar';
import { RegionReference } from '../../core/models/classes/region-reference';
import { RegionService } from '../../core/services/region.service';
import { UserService } from '../../core/services/user.service';
import { Region } from '../../core/models/classes/region';
import { SelectionModel } from '@angular/cdk/collections';
import { MatRadioChange } from '@angular/material/radio';
import { UserModel } from '../../core/models/classes/user-auth';
import { User } from '../../core/models/classes/user';
import { DatavalidityService } from '../../core/services/data-validity.service';
import { RegionRestrictions } from '../../core/models/classes/region-restrictions';
import { MAT_DATE_FORMATS } from '@angular/material/core';
import { DatePipe } from '@angular/common';

export const MY_DATE_FORMAT = {
  parse: {
    dateInput: 'DD.MM.YYYY',
  },
  display: {
    dateInput: 'DD MMM YYYY',
    monthYearLabel: 'MMM YYYY',
    dateA11yLabel: 'LL',
    monthYearA11yLabel: 'MMMM YYYY',
  }
};
providers: [{ provide: MAT_DATE_FORMATS, useClass: MY_DATE_FORMAT }];

@Component({
  selector: 'app-datavalidity',
  templateUrl: './datavalidity.component.html',
  styleUrls: ['./datavalidity.component.scss'],
  providers: [{ provide: MAT_DATE_FORMATS, useValue: MY_DATE_FORMAT }],
})

export class DatavalidityComponent implements OnInit, AfterViewInit {
  regRef: Observable<RegionReference[]>;
  assignedUsersWithReg: RegionReference[];
  filteredList: Array<Region> = [];
  selectionModel = new SelectionModel<Region>(true, []);
  chosenRegions: Array<Region> = [];
  prevChangedRegions: Array<Region> = [];
  regionId: number;
  userId: number;
  isSaveDisabled: boolean = true;
  assignedUsers: UserModel[] = [];
  userList: Array<User> = [];
  // public duration: string;
  // public interval: string;
  // public sDate: string;
  // public eDate: string;
  restriction: RegionRestrictions;
  selectionType: string = '1';
  header: string = '';
  splaceholder: string = 'Name';
  isValid: boolean = false;
  todayDate: string;
  dataSource;
  @ViewChild(MatSort) sort: MatSort;

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: any,
    private _snackBar: MatSnackBar,
    private userService: UserService,
    private regionService: RegionService,
    private datavalidityService: DatavalidityService,
    private datePipe: DatePipe,
    public dialogRef: MatDialogRef<DatavalidityComponent>
  ) {
    this.dataSource = new MatTableDataSource([]);
    this.restriction = new RegionRestrictions();
  }
  ngAfterViewInit(): void {}

  ngOnInit(): void {
    this.todayDate = this.datePipe.transform(new Date(), 'yyyy-MM-dd');
    this.regionId = this.data;
    this.getAssignedUsers();    
  }

  getAssignedUsers(){
    this.regionService.getUsers(this.regionId).subscribe({
      next: (data) => {
        this.assignedUsersWithReg = data;
        if (this.assignedUsersWithReg.length !== 0) {
          this.assignedUsersWithReg.forEach((element) => {
            this.userService.getUser(element.userID).subscribe({
              next: (userdata) => {
                this.userList.push(userdata);
                this.userList.sort((a, b) => a.name.localeCompare(b.name));
              },
            });
          });
        }
      },
      error: (err) => {},
    });
  }

  selectedUser(user: User) {
    this.isSaveDisabled = false;
    this.userId = user.id;
    this.header = user.name;
    this.splaceholder = 'Name';
    this.datavalidityService.getRestrictions(this.regionId, user.id).subscribe({
      next: (result) => {
        if (result.status === 200) {
          this.restriction = result.body;
          this.getStartDate();
          this.getInterval();          
        }
        else {
          this.restriction = new RegionRestrictions();
          this.restriction.sDate = null;
          this.restriction.eDate = null;
        }
      },
      error: (err) => {},
    });
  }

  getStartDate(){
    if(this.restriction.startDate !== null){
      var parts = this.restriction.startDate.split(".");
      this.restriction.sDate =  new Date(parseInt(parts[2], 10),
      parseInt(parts[1], 10) - 1,
      parseInt(parts[0], 10));
    }
    else{
      this.restriction.sDate =  new Date(this.datePipe.transform(this.restriction.startDate,'dd.MM.YYYY'));
    }
  }

  getInterval(){
    if(this.restriction.isInterval){
      this.selectionType = '2';
    }
    else{
      this.selectionType = '1';
      if(this.restriction.endDate !== null){
        var parts = this.restriction.endDate.split(".");
        this.restriction.eDate =  new Date(parseInt(parts[2], 10),
        parseInt(parts[1], 10) - 1,
        parseInt(parts[0], 10));
      }
      else{
        this.restriction.eDate = new Date(this.datePipe.transform(this.restriction.endDate,'dd.MM.YYYY'));
      }
    }
  }

  radioChange(event: MatRadioChange) {}

  focusField(event: any) {
    if (event.target.value < 1) {
      event.target.value = 1;
      this.restriction.duration = 1;
      this._snackBar.open($localize`Minimum duration is 1 day`, '', {
        duration: 3000,
      });
    }
    if (event.target.value > 365) {
      event.target.value = 365;
      this.restriction.duration = 365;
      this._snackBar.open($localize`Maximum duration is 365 days`, '', {
        duration: 3000,
      });
    }
  }

  onSave(): void {
    if(this.userId != undefined){
      this.restriction.userID = this.userId;
      this.isSaveDisabled = false;
    }

    this.restriction.regionID = this.regionId;
    this.restriction.isInterval = this.selectionType == '2' ? true : false;

    //validate fields
    if(this.restriction.isInterval){
      this.isIntervalScenario();    
    }
    else{
      this.isNotIntervalScenario();     
    }

    this.startEndDateCheck();
    this.assignRestrictions();   
  }

  isIntervalScenario(){
    if(String(new Date(this.restriction.sDate)) === 'Invalid Date' && this.restriction.duration === 0){
      this._snackBar.open($localize`Start date and duration not set`, '', {
        duration: 3000,
      });
    }
    else if(this.restriction.duration === 0){
      this._snackBar.open($localize`Duration not set`, '', {
        duration: 3000,
      });
    }
    else if(String(new Date(this.restriction.sDate)) === 'Invalid Date'){
      this._snackBar.open($localize`Start date not set`, '', {
        duration: 3000,
      });
    }
    else{
      this.restriction.eDate = null;
      this.isValid = true;
    }
  }

  isNotIntervalScenario(){
    if(String(new Date(this.restriction.sDate))=== 'Invalid Date' && String(new Date(this.restriction.eDate)) === 'Invalid Date'){
      this._snackBar.open($localize`Start date and end date not set`, '', {
        duration: 3000,
      });
    }
    else if(String(new Date(this.restriction.sDate)) === 'Invalid Date'){
      this._snackBar.open($localize`Start date not set`, '', {
        duration: 3000,
      });
    }
    else if(String(new Date(this.restriction.eDate)) === 'Invalid Date'){
      this._snackBar.open($localize`End date not set`, '', {
        duration: 3000,
      });
    }
    else{
      this.restriction.duration = 0;
      this.isValid = true;
    }
  }

  startEndDateCheck(){
    if(String(new Date(this.restriction.sDate)) !== 'Invalid Date'){
      this.restriction.startDate = this.datePipe.transform(this.restriction.sDate,'dd.MM.YYYY');
    }

    if(String(new Date(this.restriction.eDate)) !== 'Invalid Date'){
      this.restriction.endDate = this.datePipe.transform(this.restriction.eDate,'dd.MM.YYYY');
    }
  }

  assignRestrictions(){
    if(this.isValid){
      this.datavalidityService.setRestrictions(this.restriction).subscribe({
        next:(data) => {
          if(data.status === 200){
            this._snackBar.open($localize`Region validity set successfully`, '', {
              duration: 3000,
            });
            this.dialogRef.close();
          }
          else{
            this._snackBar.open(`Error Occurred`, '', {
              duration: 3000,
            });
          }
        }
      })
    }
  }
}
